export default {
    SET_HUBS(state, payload) {
        state.hubs = payload;
    },
    /** 임시 구독 */
    SET_TMP_SUBSCRIBE_HUB_INFO(state, payload = []) {
        state.tmpSubscribeHubInfo = payload;
    },
    // 구독 코드
    SET_SUBSCRIBE_HUB_INFO(state, payload) {
        state.subscribeHubInfo = payload;
    },
    SET_HUB_SELECTOR_DISABLED(state, payload) {
        state.isHubSelectorDisabled = payload;
    },
    SET_SUBSCRIBE_HUB_COORDINATE(state, payload) {
        state.coordinate = payload;
    },
};
